<div class="lightbox_prewiew_text" *ngIf="!isSizeChart">
    {{ data.gallery[currentIndex].type === 'image' ? 'Image' : 'Video' }}
    Preview ({{ currentIndex + 1 }} of {{ data.gallery.length }})
</div>
<div class="lightbox_prewiew_text" *ngIf="isSizeChart">Size chart</div>
<div
    class="lightbox-container"
    [@slideInOut]="currentIndex"
    (wheel)="zoomInZoomOut($event)"
>
    <a class="lightbox_close" (click)="closeLightbox()"
        ><img
            class="lightbox_icon_close"
            src="./../../../../assets/icons/lightbox_close.png"
    /></a>
    <a
        *ngIf="data.gallery.length > 1"
        [class.lightbox_arrow_disabled]="currentIndex == 0"
        class="lightbox_arrow_left"
        (click)="prevMedia()"
        ><img
            class="lightbox_icon_img"
            src="./../../../../assets/icons/{{
                currentIndex == 0
                    ? 'lightbox_arrow_left_disabled.png'
                    : 'lightbox_arrow_left.png'
            }}"
    /></a>
    <a
        *ngIf="data.gallery.length > 1"
        [class.lightbox_arrow_disabled]="
            currentIndex == data.gallery.length - 1
        "
        class="lightbox_arrow_right"
        (click)="nextMedia()"
        ><img
            class="lightbox_icon_img"
            src="./../../../../assets/icons/{{
                currentIndex == data.gallery.length - 1
                    ? 'lightbox_arrow_right_disabled.png'
                    : 'lightbox_arrow_right.png'
            }}"
    /></a>
    <div
        class="lightbox_preview_display_container"
        #lightbox_preview_display_container
        [@zoomAnimation]="zoomLevel"
    >
        <ng-container *ngIf="data.gallery[currentIndex].type === 'image'">
            <img
                [src]="data.gallery[currentIndex].url"
                [style.width.%]="zoomLevel"
                [style.height.%]="zoomLevel"
                [@zoomAnimation]="zoomLevel"
                alt="Image"
            />
        </ng-container>
        <ng-container *ngIf="data.gallery[currentIndex].type === 'video'">
            <video controls width="100%" height="auto">
                <source
                    [src]="data.gallery[currentIndex].url"
                    type="video/mp4"
                />
            </video>
        </ng-container>
    </div>
    <div class="lightbox-zoom-controls">
        <a (click)="zoomOut()"
            ><img src="./../../../../assets/icons/light_box_zoom_out.png"
        /></a>
        <a (click)="zoomIn()"
            ><img src="./../../../../assets/icons/light_box_zoom_in.png"
        /></a>
    </div>
</div>
